import React from 'react';

import Base from './Base';

const EnterpriseClubHeader = props => {
    const title = 'Provide payment for your Enterprise club';
    const subText = 'Enter payment detail below.';
    return (
        <Base title={title} subText={subText} {...props} />
    );
};

export default EnterpriseClubHeader;
